export const ACCEPTED_DATA_EXTENSIONS = [
  '.json', '.ipynb', '.csv', '.txt', '.md', '.xml', '.gpx', '.tcx', '.fit', '.gz', '.gzip', '.zip', '.xlsx',
  '.xlsm', '.docx', '.pptx', '.pdf', '.png', '.jpg', '.jpeg', '.gif', '.bmp', '.mat', '.mp4', '.m4a'
]

export const isUnsupportedFileType = (error) => {
  if (error?.response?.status === 422) return true

  return /Status: 422$/.test(String(error))
}

export async function uploadEach (files, uploadFile, onFailure) {
  let failed = 0
  for (const file of files) {
    try {
      await uploadFile(file)
    } catch (error) {
      failed += 1
      onFailure(file, error)
    }
  }
  return failed
}
